export default "__VITE_ASSET__BQnIQ$QG__"